import {
  NotificationCount,
  NotificationCountQueryParams,
  NotificationList,
  NotificationListQueryParams,
  NotificationReadAllBody,
  NotificationReadBody,
} from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import cleanDeep from 'clean-deep';

const url = '/notification';

export const getNotification = async (
  token: string,
  params: Readonly<NotificationListQueryParams>
) => {
  const { data } = await apiInstance(token).get<NotificationList>(url, {
    params: cleanDeep(params),
  });
  return data;
};

export const getNotificationCount = async (
  token: string,
  params: Readonly<NotificationCountQueryParams>
) => {
  const { data } = await apiInstance(token).get<NotificationCount>(
    `${url}/count`,
    {
      params: cleanDeep(params),
    }
  );
  return data;
};

export const putReadNotification = async (
  token: string,
  id: string,
  body: NotificationReadBody
) => apiInstance(token).put(`${url}/${id}/read`, body);

export const putReadAllNotification = async (
  token: string,
  body: NotificationReadAllBody
) => apiInstance(token).put(`${url}/read-all-unread`, body);

export const putNotificationToken = async (
  token: string,
  fcmToken: string
) =>
  apiInstance(token).put(`${url}/token`, {
    new_push_notification_token: fcmToken,
  });
